import { Data, Match } from 'effect';
import { useState } from 'react';
import { type BulkManagementTableModalKey, type FundToBulkProxy } from 'venn-components';

type State = Data.TaggedEnum<{
  opened: { mode: BulkManagementTableModalKey; investment: FundToBulkProxy };
  closed: {};
}>;
const State = Data.taggedEnum<State>();

export const useSingleProxyPickerModal = () => {
  const [state, setState] = useState<State>(State.closed());
  return {
    activeModal: Match.value(state).pipe(
      Match.tag('opened', ({ mode }) => mode),
      Match.tag('closed', () => null),
      Match.exhaustive,
    ),
    activeInvestment: Match.value(state).pipe(
      Match.tag('opened', ({ investment }) => investment),
      Match.tag('closed', () => null),
      Match.exhaustive,
    ),
    open: (mode: BulkManagementTableModalKey, investment: FundToBulkProxy) =>
      setState(State.opened({ mode, investment })),
    close: () => setState(State.closed()),
  };
};
